import React, { useState } from "react";
import { Offcanvas, Form, Row, InputGroup, Button, Spinner } from "react-bootstrap";
import { FaFolder } from "react-icons/fa";
import { FaRegFileAlt } from "react-icons/fa";
import CheckboxDropdown from "../../components/forms/checkBoxDropDown";
import { availableLanguages } from "../../components/data/language";
import { useDispatch } from "react-redux";
import { craeteGlossaryAction, uploadCsvFile } from "../../redux/actions/resourceAction";
import errorToast from "../../components/toast/errorToast";
import successToast from "../../components/toast/successToast";

const AddResource = ({ show, onHide, reloadData }) => {
  const [selectedOption, setSelectedOption] = useState("addManually");
  const [glossaryName, setGlossaryName] = useState('');
  const [glossaryType, setGlossaryType] = useState('terms_set')
  const [selectedSourceLanguage, setSelectedSourceLanguage] = useState('');
  const [selectedTargetLanguage, setSelectedTargetLanguage] = useState('');
  const [languageSets, setLanguageSets] = useState([]);
  const [fileUploadedData, setFileUploadedData] = useState({});
  const [loading, setLoading] = useState(false)
  const [uploadingFile, setUploadingFile] = useState(false)

  const dispatch = useDispatch();


  const handleSourceLanguageChange = (language) => {
    setSelectedSourceLanguage(language);
  };

  const handleTargetLanguageChange = (language) => {
    setSelectedTargetLanguage(language);
  };

  const onHandleChecked = (value, checked) => {
    if (checked) {
      setLanguageSets((prev) => [...prev, value]);
    } else {
      setLanguageSets((prev) => prev.filter((val) => val !== value));
    }
  }

  const handleSubmit = () => {
    const data = {
      glossaryId: glossaryName,
      glossary_type: glossaryType,
      file_url: fileUploadedData?.filePathUrl,
      inputUri: fileUploadedData?.gsUri,
      source_lang: selectedSourceLanguage,
      target_lang: selectedTargetLanguage,
      languageCodes: languageSets
    }
    dispatch(craeteGlossaryAction(data, onSuccess, onError));
    setLoading(true)
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    dispatch(uploadCsvFile(file, onFileUploadSuccess, onError));
    setUploadingFile(true)
  };

  const onSuccess = (data) => {
    reloadData();
    setLoading(false);
    onHide();
    successToast(data.data.message);
  };

  const onFileUploadSuccess = (data) => {
    setFileUploadedData(data.data.data);
    successToast(data.data.message);
    setUploadingFile(false)
  };

  const onError = (data) => {
    setLoading(false);
    onHide();
    errorToast(data.data.message);
  };

  const [isTouched, setIsTouched] = useState(false);
  const handleBlur = () => {
    setIsTouched(true);
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={onHide}
        placement="end"
        style={{ width: "45%" }}
        backdrop="static"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add Resource</Offcanvas.Title>
          <hr />
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <h6 className="mb-3">Glossaries</h6>
            <Form>
              <Form.Group controlId="glossaryName">
                <Form.Control type="text" placeholder="Glossary name" onChange={(e) => setGlossaryName(e.target.value)} onBlur={handleBlur} isInvalid={isTouched && !glossaryName} />
                <Form.Text className="text-muted">
                  Use letters, numbers, and underscores up to 128 characters
                </Form.Text>
              </Form.Group>
            </Form>
          </div>
          {/* <div className="mt-3">
            <h6>Select glosssary type</h6>
            <Form>
              <Form.Group controlId="glossaryType">
                <Form.Label>Glossary Type</Form.Label>
                <Form.Select placeholder="Select glossary type" onChange={(e) => setGlossaryType(e.target.value)}>
                  <option value="unidirection">
                    Unidirectional Glossary
                  </option>
                  <option value="terms_set">
                    Equivalent Term Sets Glossary
                  </option>
                </Form.Select>
              </Form.Group>
            </Form>
          </div> */}
          <div className="mt-3">
            <h6>Select file to create glossary</h6>
            {/* <div className="d-flex gap-2">
              <div className="radio-circle">
                <input
                  type="radio"
                  id="addManually"
                  name="fileSelection"
                  value="addManually"
                  checked={selectedOption === "addManually"}
                  onChange={() => handleOptionChange("addManually")}
                />
                <label htmlFor="addManually" className="checkmark"></label>
              </div>
              <div>
                <p style={{ color: "black" }}>
                  Upload files from your computer
                </p>
              </div>
            </div> */}
            {/* <div className="d-flex gap-2">
              <div className="radio-circle">
                <input
                  type="radio"
                  id="cloudStorage"
                  name="fileSelection"
                  value="cloudStorage"
                  checked={selectedOption === "cloudStorage"}
                  onChange={() => handleOptionChange("cloudStorage")}
                />
                <label htmlFor="cloudStorage" className="checkmark"></label>
              </div>
              <div>
                <p style={{ color: "black" }}>Select files on Cloud Storage</p>
              </div>
            </div> */}
            {selectedOption === "addManually" && (
              <>
                <div className="pt-1">
                  {/* <h6>Select destination for uploaded file</h6> */}
                  <div className="d-flex gap-3">
                    <label for="fileInput" class="custom-file-upload fs_14 fw_400 fn_Roboto">
                      {uploadingFile ? <Spinner size="sm" className="mt-1" /> : ""}
                      <span className="">{!uploadingFile ? ' Select Files' : ' Uploading'}</span>
                    </label>
                    <input id="fileInput" type="file" name="file" style={{ display: " none" }} onChange={handleFileChange} />
                    <label className="mt-2">{fileUploadedData?.originalName}</label>
                  </div>

                </div>
              </>
            )}
            {selectedOption === "cloudStorage" && (
              <>
                <br />
                <div>
                  <Form className="cloud_form">
                    <Form.Group as={Row} controlId="formDays">
                      <div>
                        <InputGroup>
                          <InputGroup.Text>
                            <FaRegFileAlt size={22} />
                          </InputGroup.Text>
                          <Form.Control type="type" placeholder="gs://" />
                          <Button className="btn-secondary text-align: end">
                            BROWSE
                          </Button>
                        </InputGroup>
                      </div>
                    </Form.Group>
                  </Form>
                </div>
              </>
            )}
            <h6 className="pt-4">Select Language</h6>
            {glossaryType === "unidirection" ?
              <div className="d-flex gap-3 w-75">
                <div >
                  <Form>
                    <Form.Group controlId="sourceLanguage">
                      <Form.Label>Source Language</Form.Label>
                      <Form.Select
                        onChange={(e) =>
                          handleSourceLanguageChange(e.target.value)
                        }
                      >
                        <option value="">Select source language</option>
                        {availableLanguages.map((item, index) => (
                          <option value={item.value} key={index}>{item.label}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Form>
                </div>
                <div>
                  <Form>
                    <Form.Group controlId="targetLanguage">
                      <Form.Label>Target Language</Form.Label>
                      <Form.Select
                        onChange={(e) =>
                          handleTargetLanguageChange(e.target.value)
                        }
                      >
                        <option value="">Select target language</option>
                        {availableLanguages.map((item, index) => (
                          <option value={item.value} key={index}>{item.label}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Form>
                </div>
              </div>
              :
              <div className="mx-2">
                <CheckboxDropdown
                  name="languages"
                  options={availableLanguages}
                  onHandleChecked={onHandleChecked}
                  isOpen={true}
                  selectedValues={languageSets}
                />
              </div>
            }
            <div className="d-flex gap-4 mx-3 mt-4 mb-2">
              <Button
                disabled={loading || !glossaryName || !fileUploadedData?.filePathUrl || languageSets.length === 0}
                variant='primary'
                className='d-flex text-nowrap'
                style={{ minWidth: '80px' }}
                onClick={handleSubmit}
              >
                <div className='fs_12 d-flex gap-2 justify-content-center'>
                  {loading ? <Spinner size="sm" className="mt-1" /> : ""}
                  <label className="fs_16">{!loading ? 'Create' : 'Creating'}</label>
                </div>
              </Button>
              <button className="btn btn-button btn-danger fs_18" style={{ width: '80px' }} disabled={loading} onClick={onHide}>
                <label className="">Close</label>
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AddResource;
